<script lang="ts">
    const items = [
        {
            title: "Kontakt z kancelarią",
            text: "Odwieź nasze biuro, zadzwoń lub napisz.",
            icon: "chat-icon.svg"
        },
        {
            title: "Omówienie szczegółów",
            text: "W wybranej formie kontaktu.",
            icon: "discuss-icon.svg"
        },
        {
            title: "Przekazanie dokumentów",
            text: "Osobiście lub mailowo.",
            icon: "documentsValidation-icon.svg"
        },
        {
            title: "Podpisanie aktu notarialnego",
            text: "W siedzibie kancelarii.",
            icon: "signature-icon.svg"
        }
    ]
</script>

<section class="section">
    <div class="container">
        <h2 class="heading section__heading">Schemat postępowania</h2>

        <ul class="scheme">
            {#each items as item}
                <li class="scheme-item">
                    <div class="scheme-item__icon">
                        <img src="/{item.icon}" class="scheme-item__icon-img" alt={item.title} />
                    </div>
                    <span class="scheme-item__title">{item.title}</span>
                    <span class="scheme-item__text">{item.text}</span>
                </li>
            {/each}
            </ul>
    </div>
</section>

<style>
    .section {
        background: #fcf8f3;
    }

    .scheme {
        display: flex;
        flex-direction: column;
        gap: 3rem;
        padding: 0;
        margin: 0;
        list-style: none;
    }

    .scheme-item {
        display: block;
        text-align: center;
    }
    
    .scheme-item__title {
        display: block;
        font-size: 1rem;
        font-weight: bold;
        text-transform: uppercase;
    }

    .scheme-item__text {
        display: block;
        text-align: center;
    }

    .scheme-item__icon {
        display: flex;
        align-items: center;
        justify-content: center;
        margin: 0 auto 1rem auto;
        border: 4px solid var(--color-theme-1);
        border-radius: 100%;
        text-align: center;
        width: 200px;
        height: 200px;
    }

    .scheme-item__icon-img {
        width: 50%;
        height: 50%;
    }

    @media (min-width: 768px) {
        .scheme {
            flex-direction: row;
            justify-content: space-around;
        }

        .scheme-item {
            display: flex;
            flex-direction: column;
            align-items: center;
        }

        .scheme-item__icon {
            width: 140px;
            height: 140px;
        }
    }

    @media (min-width: 1024px) {
        .scheme-item__icon {
            width: 200px;
            height: 200px;
        }
    }
</style>